module.exports = __webpack_public_path__ + "img/1492008134.2a4adfa9.jpg";